module.exports = __webpack_public_path__ + "img/Umb42_uv_logoside_2383.972b903f.svg";